<div *ngIf="order" class="content-area">
  <ng-container *ngIf="state.familyPlanVehicles.length > 0; else regularVehicleDetails">
    <!-- Header outside white background -->
    <div class="family-plan-header">
      <h3 class="content-title">Choose Vehicle</h3>
      <button class="add-vehicle-btn" (click)="onAddVehicle()">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 3.33334V12.6667"
            stroke="#1366FB"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M3.33334 8H12.6667"
            stroke="#1366FB"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        Add Vehicle
      </button>
    </div>

    <!-- White background container -->
    <div class="family-plan-content">
      <div class="family-vehicles-list">
        <app-vehicle-card
          *ngFor="let v of state.familyPlanVehicles; trackBy: trackByIndex"
          [vehicle]="{
            id: v.id,
            name: getVehicleDisplayName(v),
            licensePlate: v.license_plate,
            vin: v.vin,
            isFamilyPlanVehicle: true,
          }"
          [isParentVehicleCard]="true"
          [selectable]="true"
          [selected]="state.selectedVehicleId === v.id"
          [selectionType]="'radio'"
          [selectionName]="'familyVehicle'"
          [showFamilyPlanStatus]="false"
          [showDeleteButton]="false"
          [useMobileMenu]="true"
          (selectionChange)="selectVehicle(v.id)"
          (editVehicle)="onEditFamilyVehicle(v)"
          (deleteVehicle)="onDeleteFamilyVehicle(v)"
        ></app-vehicle-card>
      </div>

      <div class="family-plan-footer">
        <button type="button" class="btn-cancel" (click)="onCancelFamilyPlan()">Cancel</button>
        <div class="footer-right">
          <button type="button" class="btn-back" (click)="onBackFamilyPlan()">Back</button>
          <button
            type="button"
            class="btn-select"
            [disabled]="!state.selectedVehicleId"
            (click)="onSelectVehicle()"
          >
            Select Vehicle
          </button>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Regular Vehicle Details (tab label is "Vehicle Details" — no duplicate heading) -->
  <ng-template #regularVehicleDetails>
    <!-- Edit Mode -->
    <div *ngIf="state.isVehicleEditMode; else vehicleReadOnly" class="vehicle-edit-container">
      <!-- Shimmer Loading State -->
      <div *ngIf="state.isLoadingVehicleDetails" class="vehicle-edit-content">
        <div class="shimmer-container">
          <div class="form-section">
            <div class="form-row">
              <div class="form-field">
                <div class="shimmer-label"></div>
                <div class="shimmer-input"></div>
              </div>
              <div class="form-field">
                <div class="shimmer-label"></div>
                <div class="shimmer-input"></div>
              </div>
            </div>
          </div>
          <div class="form-section">
            <div class="form-row">
              <div class="form-group">
                <div class="shimmer-label"></div>
                <div class="shimmer-input"></div>
              </div>
              <div class="form-group">
                <div class="shimmer-label"></div>
                <div class="shimmer-input"></div>
              </div>
            </div>
            <div class="form-row single">
              <div class="form-group full">
                <div class="shimmer-label"></div>
                <div class="shimmer-input"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Form Content (shown when not loading) -->
      <div *ngIf="!state.isLoadingVehicleDetails" class="vehicle-edit-content">
        <form class="vehicle-edit-form" (ngSubmit)="onSaveVehicleEdit()">
          <!-- First Section: State + License Plate -->
          <div class="form-section">
            <div class="form-row">
              <!-- State Field -->
              <div class="form-field">
                <label class="field-label">State<span class="asterisk">*</span></label>
                <div class="select-wrapper p-custom-select">
                  <mat-select
                    class="form-select"
                    panelClass="order-details-select-panel"
                    disableOptionCentering
                    [(ngModel)]="state.vehicleForm.state"
                    name="state"
                    placeholder="Select State"
                  >
                    <app-select-search #statesSearch placeholder="Search"></app-select-search>
                    <mat-option
                      *ngFor="
                        let usState of states | selectFilter: statesSearch.query : ['name', 'code']
                      "
                      [value]="usState.code"
                      >{{ usState.name }}</mat-option
                    >
                  </mat-select>
                </div>
              </div>

              <!-- License Plate Field -->
              <div class="form-field">
                <label class="field-label">License Plate<span class="asterisk">*</span></label>
                <div class="input-wrapper">
                  <input
                    type="text"
                    class="form-input"
                    placeholder="Enter license plate"
                    [(ngModel)]="state.vehicleForm.licensePlate"
                    name="licensePlate"
                  />
                  <button
                    class="fetch-btn"
                    (click)="onFetchVehicleDetails()"
                    [disabled]="!canFetchVehicle || state.isLoadingVehicle"
                  >
                    <svg
                      *ngIf="!state.isLoadingVehicle"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M4.17 6.67L15.83 6.67M15.83 6.67L11.67 2.5M15.83 6.67L11.67 10.83"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <div *ngIf="state.isLoadingVehicle" class="loading-spinner"></div>
                  </button>
                </div>
              </div>
            </div>

            <!-- Fetch result note -->
            <div class="fetch-result" *ngIf="state.vehicleFetchSuccess">
              <div class="success-icon">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="7" cy="7" r="6" fill="#079271" stroke="#079271" stroke-width="1" />
                  <path
                    d="M4.5 7L6 8.5L9.5 5"
                    stroke="#FFFFFF"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <span class="fetch-text">Details fetched</span>
            </div>

            <!-- CWS-1384: the saved vehicle details could not be loaded. Say so, rather
                 than leave Year/Make/Model mysteriously blank. -->
            <div class="fetch-error" *ngIf="state.vehicleDetailsLoadError">
              {{ state.vehicleDetailsLoadError }}
            </div>

            <!-- CWS-1384: this car carries a live membership, which follows the plate. -->
            <div class="membership-sync-hint" *ngIf="activeMembershipNotice">
              {{ activeMembershipNotice }}
            </div>

            <!-- CWS-1384: imported customer — the vendor owns the plate of record. Shown
                 while editing, and never blocks the save. -->
            <div class="vendor-sync-hint" *ngIf="vendorPlateSyncNotice">
              {{ vendorPlateSyncNotice }}
            </div>

            <!-- Lookup miss: same amber prompt as the Add/Edit Vehicle card -->
            <div
              class="fetch-hint"
              *ngIf="state.vehicleLookupMessage && !state.vehicleFetchSuccess"
            >
              {{ state.vehicleLookupMessage }}
            </div>
          </div>

          <!-- Second Section: Vehicle Details -->
          <div class="form-section">
            <div class="form-row">
              <div class="form-group">
                <label class="form-label">Year</label>
                <input
                  class="form-input"
                  type="text"
                  [(ngModel)]="state.vehicleForm.year"
                  name="year"
                  placeholder="Enter year"
                />
              </div>
              <div class="form-group">
                <label class="form-label">Make</label>
                <input
                  class="form-input"
                  type="text"
                  [(ngModel)]="state.vehicleForm.make"
                  name="make"
                  placeholder="Enter make"
                />
              </div>
            </div>

            <div class="form-row single">
              <div class="form-group full">
                <label class="form-label">Model</label>
                <input
                  class="form-input"
                  type="text"
                  [(ngModel)]="state.vehicleForm.model"
                  name="model"
                  placeholder="Enter model"
                />
              </div>
            </div>
          </div>
        </form>
      </div>

      <!-- Fixed Footer actions -->
      <div class="vehicle-edit-footer">
        <button type="button" class="btn-cancel" (click)="onCancelVehicleEdit()">Cancel</button>
        <button
          type="button"
          class="btn-save"
          [disabled]="isSaveDisabled"
          (click)="onSaveVehicleEdit()"
        >
          Save
        </button>
      </div>
    </div>

    <!-- Read-only Mode -->
    <ng-template #vehicleReadOnly>
      <div class="vehicle-details-card">
        <div class="vehicle-details-content">
          <!-- Vehicle Header with Actions -->
          <div class="vehicle-header">
            <div class="vehicle-name">{{ getVehicleDisplayNameForOrder() }}</div>
            <div class="vehicle-actions" *ngIf="canEditVehicle()">
              <!-- Desktop/Tablet: Show edit icon -->
              <button
                class="action-btn edit-btn desktop-edit-btn"
                (click)="onVehicleEdit()"
                title="Edit Vehicle"
              >
                <img
                  src="assets/images/vehicle-details/edit-icon.svg"
                  alt="Edit"
                  width="20"
                  height="20"
                />
              </button>

              <!-- Mobile: Show three-dot menu -->
              <div class="mobile-actions">
                <button
                  class="mobile-menu-btn"
                  (click)="toggleVehicleMobileMenu($event)"
                  [class.active]="state.showVehicleMobileMenu"
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="8" cy="3" r="1.5" fill="#555A63" />
                    <circle cx="8" cy="8" r="1.5" fill="#555A63" />
                    <circle cx="8" cy="13" r="1.5" fill="#555A63" />
                  </svg>
                </button>

                <!-- Mobile Menu Dropdown -->
                <div
                  class="mobile-menu-dropdown"
                  *ngIf="state.showVehicleMobileMenu"
                  (click)="$event.stopPropagation()"
                >
                  <div
                    class="mobile-menu-item"
                    (click)="onVehicleEdit(); state.showVehicleMobileMenu = false"
                  >
                    <svg
                      class="menu-icon"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.3333 2.00001C11.5084 1.8249 11.7163 1.686 11.9453 1.59128C12.1742 1.49657 12.4191 1.44775 12.6667 1.44775C12.9142 1.44775 13.1591 1.49657 13.3881 1.59128C13.617 1.686 13.8249 1.8249 14 2.00001C14.1751 2.17512 14.314 2.38302 14.4087 2.61197C14.5034 2.84092 14.5522 3.0858 14.5522 3.33334C14.5522 3.58088 14.5034 3.82576 14.4087 4.05471C14.314 4.28366 14.1751 4.49156 14 4.66667L5 13.6667L1.33333 14.6667L2.33333 11L11.3333 2.00001Z"
                        stroke="#555A63"
                        stroke-width="1.33333"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <span>Edit</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Vehicle Info Grid -->
          <div class="vehicle-info-grid">
            <div class="info-row-container">
              <div class="info-column">
                <span class="info-label">LICENSE PLATE</span>
                <span class="info-value">{{ order.licensePlate || 'N/A' }}</span>
              </div>
              <div class="info-column">
                <span class="info-label">VIN NUMBER</span>
                <span class="info-value">{{ order.vin || 'N/A' }}</span>
              </div>
            </div>

            <div class="info-row-container single-column">
              <div class="info-column">
                <span class="info-label">FAMILY PLAN VEHICLE</span>
                <span class="info-value">{{ order.isFamilyPlanVehicle ? 'Yes' : 'No' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </ng-template>
</div>
